export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9158.1b953db4.jpg";